import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import communityApi from '../../api/communityApi';
import { UserInterface } from "../../store/community/usersSlice";
import communityUrls from "../../configs/community/communityUrls";

const PREFIX = 'community';

const processStrategy = (value: any) => {
  return {
    ...value,
    avatar_url: communityUrls.remoteUrl(value.avatar_url),
    url: communityUrls.userPath(value.id)
  };
}

export const usersEntity = new schema.Entity(
  'users',
  {},
  {
    processStrategy
  }
);

export const userEntity = new schema.Entity(
  'user',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      user: UserInterface
    }
  >(response.data.user, userEntity);
  return normalized.entities;
}

export const fetchUsers = createAsyncThunk(
  `${PREFIX}_users/fetchUsers`,
  async (params: object = {}) => {
    const response    = await communityApi.get(`/onesky/users`, { params })
    const normalized  = normalize<
      any,
      {
        users: { [key: string]: UserInterface },
      }
    >(response.data.users, [usersEntity]);

    return {
      users: normalized.entities?.users || {},
      ids: normalized.result,
      count: response.data.meta?.total_count
    };
  }
);

export const fetchUser = createAsyncThunk(
  `${PREFIX}_users/fetchUser`,
  async (id: number | string) => {
    const response = await communityApi.get(`/onesky/users/${id}`);
    return normalizeInstance(response);
  }
);

export const updateUser = createAsyncThunk(
  `${PREFIX}_users/updateUser`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await communityApi.patch(`/onesky/users/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyUser = createAsyncThunk(
  `${PREFIX}_users/destroyUser`,
  async (id: number) => {
    await communityApi.delete(`/onesky/users/${id}`);
    return { id: id };
  }
);

export const blockUser = createAsyncThunk(
  `${PREFIX}_users/blockUser`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await communityApi.patch(`/onesky/users/${id}/block`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
